import { Injectable } from '@angular/core';
import { DatabaseProvider } from '../database/database';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ConfigDataProvider } from '../config-data/config-data';
import { File } from '@ionic-native/file';

@Injectable()
export class UsersStoreProvider {

	private db = new DatabaseProvider();
	public usersList: BehaviorSubject<any> = new BehaviorSubject([]);
	public myUsersList: BehaviorSubject<any> = new BehaviorSubject([]);

	constructor(
		private configDataProvider: ConfigDataProvider,
		private file: File,
	) {

	}

	addBatch(usersList) {

		return new Promise((resolve, reject) => {

			this.db.users.clear().then(() => {

				usersList = this.modifyUserListBeforeInsert(usersList);

				this.db.users.bulkAdd(usersList).then((data) => {
					this.loadList();
					resolve(data);
				}).catch((e) => reject(e))

			}).catch((e) => reject(e))

		})

	}

	modifyUserListBeforeInsert(list) {

		let userList = [];

		for (var key in list) {
			userList.push(list[key]);
		}

		/* list.map((val) => {

			if (!isBrowser()) {
				if (val.picture != '' && val.picture != null && val.picture != "null") {
					var filepath = this.file.dataDirectory + '/' + val.picture;
					var url = this.configDataProvider.getcaredocurl() + '/customerspaces/' + val.customercode + '/userpictures/' + val.picture;
					this.fileTransfer = this.transfer.create();
					this.fileTransfer.download(url, filepath).then((entry) => {
						console.log(entry);
					}, (error) => {
						console.log(error)
					});
				}
			}
		}); */

		return userList;

	}

	loadList() {

		return new Promise((resolve, reject) => {

			this.db.users.toArray().then((data) => {
				let userslist = this.manipulateList(data);
				this.usersList.next(userslist);
				resolve();

			}).catch((e) => {
				console.log(e);
				reject(e)
			});

		})


	}


	private manipulateList(usersList) {

		var users = [];
		var userpics = [];
		var index = 1;
		// let userscount = 0;
		let upic = "";

		if (usersList && usersList.length > 0) {

			usersList.forEach((user) => {

				if (user.type == 'user') {
					// userscount++;
					if (user.picture != '' && user.picture != null) {
						// if ((!ionic.Platform.isAndroid() && !ionic.Platform.isIOS() && !ionic.Platform.isIPad()))
						// 	upic = user.picture;
						// else{
						// 	if(cordova.platformId == "browser"){
						// 		upic = user.picture;
						// 	}else {
						// 		upic = toolsService.getFilePath(user.picture);
						// 	}
						// }
						upic = ((user.picture != '' && user.picture != null && user.picture != "null") ?
							(this.configDataProvider.getcaredocurl() + '/customerspaces/' + user.customercode + '/userpictures/' + user.picture) : null);
						// upic = './assets/imgs/avatar.jpg';
					}
					else {
						upic = './assets/imgs/avatar.jpg';
					}
				}
				else {
					upic = ((user.picture != '' && user.picture != null && user.picture != "null") ?
						(this.configDataProvider.getcaredocurl() + '/customerspaces/' + user.customercode + '/userpictures/' + user.picture) : './assets/imgs/avatar_group.jpg');
				}
				if (user.type == 'user') {
					userpics.push({ id: user.id, pic: upic, fname: user.fname });
				}
				var phone = '';
				if (user.telefoonintern != '' || user.telefoonintern != null) {
					phone = user.telefoonintern;
				}

				if (user.gsmintern != '' || user.gsmintern != null) {
					phone = user.gsmintern;
				}
				var groupusers = '';
				if (user.users != '' && user.users != null) {
					groupusers = user.users.split(';').join(', ');
				}
				var uid = '';
				if (user.type == 'user') {
					uid = user.id;
				}
				else {
					uid = user.id;
					if (user.id.indexOf('G:') === -1) {
						uid = 'G:' + user.id;
					}
				}
				users.push({
					id: uid,
					fname: user.fname,
					picture: upic,
					userfunction: user.userfunction,
					phone: phone,
					users: groupusers,
					userids: user.userids,
					type: user.type,
					index: index,
					showusers: false,
					selected: false,
					hide: false,
					usercount: 0,
				});
				index++;
			})
		}

		users.forEach((tmpUser) => {

			var picstring = '';

			if (tmpUser['type'] == 'group' && tmpUser['userids'] != null && tmpUser['userids'].length > 0) {

				var gusers = tmpUser['userids'].split(';');

				if (gusers && gusers.length > 0) {

					gusers.forEach((tmpGuser) => {

						var obj = null;

						if (userpics && userpics.length > 0) {
							userpics.forEach((tmpUser) => {
								if (tmpUser.id == tmpGuser) {
									obj = tmpUser;
								}
							})
						}

						if(obj && obj.pic){
							picstring += '<div class="groupuser">' +
								'   <div class="groupuseravatar"><img src="' + obj.pic + '" class="small-avatar"/></div>' +
								'   <div class="groupusername">' + obj.fname + '</div>' +
								'</div>';
						}

					})

				}

				tmpUser['usercount'] = gusers.length;
			}

			tmpUser['picstring'] = picstring;
		})

		// sort users array by fname A to Z order

		users.sort((u1, u2) => {
			if (u1.fname < u2.fname) { return -1; }
			if (u1.fname > u2.fname) { return 1; }
			return 0;
		});


		//users[0]['usercount'] = userscount;
		//Move Everyone group to the start of the array

		for (var i = 0; i < users.length; i++) {
			if (users[i].id == 'G:ALL') {
				var a = users.splice(i, 1);   // removes the item
				users.unshift(a[0]);         // adds it back to the beginning
				break;
			}
		}

		return users;

	}

	addBatchAllUsers(myUsersList) {

		return new Promise((resolve, reject) => {

			this.db.myUsers.clear().then(() => {

				this.db.myUsers.bulkAdd(myUsersList).then((data) => {

					this.loadAllMyUsersList();
					resolve(data);

				}).catch((e) => reject(e))

			}).catch((e) => reject(e))

		})

	}

	loadAllMyUsersList() {

		return new Promise((resolve, reject) => {

			this.db.myUsers.toArray().then((userList) => {

				let list = [];

				if (userList && userList.length > 0) {
					list = userList;
				}

				this.myUsersList.next(list);

				resolve(true);

			})

		})

	}

	getFilePath(name) {
		let path = this.file.dataDirectory + '/' + name;
		let url = (window as any).Ionic.WebView.convertFileSrc(path);
		return url;
	}


	getCurrentUser() {

		var currentdate = new Date();
		var date: any = currentdate.getDate();
		date = date < 10 ? '0' + date : date;
		var month: any = currentdate.getMonth() + 1;
		month = month < 10 ? '0' + month : month;
		var year: any = currentdate.getFullYear();
		year = year < 10 ? '0' + year : year;
		var min: any = currentdate.getMinutes();
		min = min < 10 ? '0' + min : min;
		var hours: any = currentdate.getHours();
		hours = hours < 10 ? '0' + hours : hours;

		var datetime = date + '/' + month + '/' + year + ' ' + hours + ':' + min;

		let user = this.configDataProvider.getUserData();


		if (user && user.userpicture) {
			user.userpicture = "./assets/imgs/avatar.jpg";
		} else {
			user.userpicture = "./assets/imgs/avatar.jpg";
		}

		user.lastsync = datetime;


		return user;


	}

}



// WEBPACK FOOTER //
// ./src/providers/users-store/users-store.ts